import { render, staticRenderFns } from "./ClassicTabBar.vue?vue&type=template&id=2184dcb0&scoped=true"
import script from "./ClassicTabBar.vue?vue&type=script&lang=js"
export * from "./ClassicTabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184dcb0",
  null
  
)

export default component.exports